export const getErrorResponse = (error: Error) => {
  let errors = []
  if (typeof error.data?.message == "object") {
    errors = error.data?.message?.map((message) => `${message}\n`).join("")
  }
  return errors.length ? errors : error.data.message
}
